import { useLanguage } from "@/i18n/LanguageContext";

export default function StatsSection() {
  const { t } = useLanguage();

  const stats = [
    { value: "1,500+", label: t("home.stat1Label"), sizeClass: "text-5xl" },
    { value: "< 2HR", label: t("home.stat2Label"), sizeClass: "text-[40px]" },
    { value: "12", label: t("home.stat3Label"), sizeClass: "text-5xl" },
    { value: "500+", label: t("home.stat4Label"), sizeClass: "text-5xl" },
  ];

  return (
    <section className="w-full bg-[#047857] py-10">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className={`${stat.sizeClass} font-black text-white mb-1`}>
                {stat.value}
              </div>
              <div className="text-sm text-[#fefce8]">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}